import { arrayOf, string, shape } from 'prop-types';
import React, { Fragment } from 'react';

// defined in GTM "Recipe Equipment Affiliate Link *" triggers
export const AFFILIATE_LINK_CLASS = 'affiliate-link';

function RecipeSupplyItem(props) {
  const { quantity, unit, html, affiliateLink, id } = props;

  const url = affiliateLink ? affiliateLink.url : null;

  const name = <span dangerouslySetInnerHTML={{ __html: html }} />;
  const item = url ? (
    <a
      href={url}
      className={AFFILIATE_LINK_CLASS}
      data-gtm-ignore-outbound-link="true"
      // NOTE, typically noopener and noreferrer should be used when opening
      // links in a new tab. However it is unclear if this breaks certain affiliate
      // services, or violates Amazon's terms of use.
      /* eslint-disable react/jsx-no-target-blank */
      rel="nofollow"
      target="_blank"
    >
      {name}
    </a>
  ) : (
    name
  );

  return (
    <li className="Recipe__supplyItem" key={id}>
      {quantity && <span>{quantity} </span>}
      {unit && <span>{unit} </span>}
      {item}
    </li>
  );
}

function RecipeSupplyGroup(group) {
  const { id, name, items } = group;

  return (
    <div className="Recipe__suppliesGroup" key={id}>
      {name && <h4 className="Recipe__suppliesGroupName">{name}</h4>}
      {items && items.length > 0 ? (
        <ul className="Recipe__supplies">{items.map(RecipeSupplyItem)}</ul>
      ) : null}
    </div>
  );
}

function RecipeSupplies(props) {
  const { groups } = props;

  return (
    <Fragment>
      {groups && groups.length
        ? groups
            .slice(0)
            .sort((a, b) => a.position - b.position)
            .map(RecipeSupplyGroup)
        : null}
    </Fragment>
  );
}

RecipeSupplies.propTypes = {
  groups: arrayOf(
    shape({
      id: string,
      name: string,
      items: arrayOf(
        shape({
          id: string,
          quantity: string,
          unit: string,
          html: string,
          affiliateLink: shape({
            url: string
          })
        })
      )
    })
  )
};

RecipeSupplies.defaultProps = {
  groups: undefined
};

export default RecipeSupplies;
